import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import React from "react";
import MDButton from "../../../Components/MDButton";
import {ErrorToaast, SuccessToaast} from "../../../utils/toast/Toast";
import {ServiceModel} from "../../../Api/Models/ServiceModel";

interface IDeleteRows {
  open: boolean;
  setClose: any;
  onDone: any;
  id: number;
}
export default function DeleteDialog(props: IDeleteRows) {
  const model = new ServiceModel();
  function handleDelete() {
    model
      .delete(props.id)
      .then((r) => {
          SuccessToaast("با موفقیت حذف شد")
        props.onDone();
      })
      .catch((e) => ErrorToaast("خطا در برقراری ارتباط"));
  }
  return (
    <Dialog open={props.open} onClose={props.setClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">آیا از حذف نوع سرویس  مورد نظر اطمینان دارید؟</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          با حذف  نوع سرویس  مورد نظر دیگر قابل مشاهده نمیباشد , ایا از انجام این کار اطمینان دارید؟
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton color="success" onClick={handleDelete}>
          حذف
        </MDButton>
        <MDButton onClick={props.setClose} autoFocus color="warning">
          بازگشت
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
